// extracted by mini-css-extract-plugin
var _1 = "ApplicantDecisionStep-moduleApplicantDecisionStep__FSfLR";
var _2 = "ApplicantDecisionStep-modulecontent__aeDN6";
var _3 = "ApplicantDecisionStep-modulehead__qGBDD";
var _4 = "ApplicantDecisionStep-modulelabel__FGlJm";
var _5 = "ApplicantDecisionStep-modulenumber__qLw20";
export { _1 as "ApplicantDecisionStep", _2 as "content", _3 as "head", _4 as "label", _5 as "number" }
